import { gql } from '@apollo/client/core';

export const CREATE_COPILOT_NOTIFICATION_MUTATION = gql`
  mutation CreateNotificationWithEmail($studentEmail: String) {
    createCopilotNotification(input: {status: ACTIVE, studentEmail: $studentEmail, type: UI_GENERATED, message: "{\\"name\\": \\"ReadTheory Skipping\\"}"}) {
      id
    }
  }
`;
